import React from "react"
import { useTranslation } from "react-i18next"
import PhoneAndroidOutlinedIcon from "@mui/icons-material/PhoneAndroidOutlined"
import FlipCameraIosOutlinedIcon from "@mui/icons-material/FlipCameraIosOutlined"
import Theme from "../../library/Theme"
import {Fade, Stack} from "@mui/material"
import BigButton from "../buttons/BigButton"

interface CameraControlsProps {
  theme: Theme
  canSwitchCamera: boolean
  switchCamera: () => void
  switchDevice: () => void
}

export default function CameraControls({
  theme,
  canSwitchCamera,
  switchCamera,
  switchDevice,
}: CameraControlsProps) {
  const { t } = useTranslation()

  return (
    <Fade
      in
      timeout={500}
    >
      <Stack
        spacing={2}
        justifySelf="center"
        sx={{ mt: 3, color: theme.textColor }}
      >
        {canSwitchCamera ? (
          <BigButton variant="text" size="small" onClick={switchCamera}>
            <FlipCameraIosOutlinedIcon sx={{mr: 1}}/>
            {t("capture.switchCamera")}
          </BigButton>
        ) : (
          <BigButton variant="text" size="small" onClick={switchDevice}>
            <PhoneAndroidOutlinedIcon sx={{mr: 1}}/>
            {t("common.switchDevice")}
          </BigButton>
        )}
      </Stack>
    </Fade>
  )
}
